import { CheckIcon, CopyIcon, ExternalLinkIcon } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import {
  standardButtonVariants,
  standardIconVariants,
  standardLinkVariants,
} from '~/components/component-library/Copyable/styles'
import { StandardCopyableProps } from '~/components/component-library/Copyable/types'
import {
  SENSITIVE_ANALYTICS_ATTRIBUTES,
  SESSION_REPLAY_BLOCK_CLASS,
  truncate,
} from '~/components/component-library/Copyable/utils'
import { useCopyValue } from '~/hooks/useCopyValue'
import { cn } from '~/utils/tailwind-utils'

export const StandardCopyable = ({
  value,
  displayValue,
  size = 'base',
  truncateMiddle = false,
  href,
  successMessage,
  sensitive = false,
}: StandardCopyableProps) => {
  const { isCopied, handleCopy, handleCopySecret } = useCopyValue()
  const copy = sensitive ? handleCopySecret : handleCopy
  const display = displayValue ?? truncate(value, truncateMiddle)

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={(event) => {
          event.preventDefault()
          event.stopPropagation()
          copy(value, successMessage ?? 'Copied')
        }}
        aria-label={sensitive ? 'Copy value' : `Copy ${value}`}
        className={cn(standardButtonVariants({ size }), {
          [SESSION_REPLAY_BLOCK_CLASS]: sensitive,
        })}
        {...(sensitive && SENSITIVE_ANALYTICS_ATTRIBUTES)}
      >
        <span>{display}</span>
        {isCopied ? (
          <CheckIcon className={standardIconVariants({ size })} />
        ) : (
          <CopyIcon className={standardIconVariants({ size })} />
        )}
      </button>
      {href && (
        <SplitsLink
          target={href.target}
          path={href.path}
          onClick={(event) => event.stopPropagation()}
          className={standardLinkVariants()}
        >
          <ExternalLinkIcon className={standardIconVariants({ size })} />
        </SplitsLink>
      )}
    </div>
  )
}
